<template>
  <BreadCrumb PageTitle="Modifier bon de reception" />
  <ScanReturn  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ScanReturn from "@/components/Notes/Return/Zone/ScanReturn.vue";

import { useRoute } from "vue-router";
export default defineComponent({
  name: "ScanReturnPage",
  components: {
    BreadCrumb,
    ScanReturn,
  },

  setup: () => {
    const route = useRoute();
    let id = route.params.id; 
    if (Array.isArray(id)) {
      id = id[0] ?? "";
    }

    let refNote = route.params.refNote; 
    if (Array.isArray(refNote)) {
      refNote = refNote[0] ?? "";
    }


    return { id , refNote};
}
});
</script>